import type { IllegalCustomQuestionResponse } from '../types';

export class IllegalCustomQuestions extends Error {
  illegalQuestions: IllegalCustomQuestionResponse[];

  constructor(illegalQuestions: IllegalCustomQuestionResponse[]) {
    super();
    this.illegalQuestions = illegalQuestions;
  }
}
